import styled from 'styled-components';
import { SimpleSelect } from './AppSelect';

export const StyledInput = styled.input`
    width: 100%;
    padding: 0.75rem 0.875rem;
    border: 1.5px solid ${({ $error }) => ($error ? '#dc3545' : '#e5e7eb')};
    border-radius: 10px;
    font-size: 0.95rem;
    background: ${({ readOnly }) => (readOnly ? '#f9fafb' : '#ffffff')};
    transition: all 0.2s ease;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.03);
    outline: none;
    color: #111827;

    &:focus {
        border-color: ${({ $error }) => ($error ? '#dc3545' : '#821692')};
        box-shadow: 0 0 0 4px ${({ $error }) => ($error ? 'rgba(220, 53, 69, 0.1)' : 'rgba(130, 22, 146, 0.1)')};
    }

    &::placeholder {
        color: #9ca3af;
    }

    &:disabled {
        background-color: #f3f4f6;
        cursor: not-allowed;
        opacity: 0.7;
    }
`;

export const StyledTextArea = styled.textarea`
    width: 100%;
    padding: 0.75rem 0.875rem;
    border: 1.5px solid ${({ $error }) => ($error ? '#dc3545' : '#e5e7eb')};
    border-radius: 10px;
    font-size: 0.95rem;
    min-height: 100px;
    resize: vertical;
    background: ${({ readOnly }) => (readOnly ? '#f9fafb' : '#ffffff')};
    transition: all 0.2s ease;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.03);
    outline: none;
    color: #111827;
    font-family: inherit;

    &:focus {
        border-color: ${({ $error }) => ($error ? '#dc3545' : '#821692')};
        box-shadow: 0 0 0 4px ${({ $error }) => ($error ? 'rgba(220, 53, 69, 0.1)' : 'rgba(130, 22, 146, 0.1)')};
    }

    &::placeholder {
        color: #9ca3af;
    }

    &:disabled {
        background-color: #f3f4f6;
        cursor: not-allowed;
        opacity: 0.7;
    }
`;

export const StyledSelect = styled(SimpleSelect)`
    width: 100%;
    font-size: 0.95rem;
`;

export const StyledLabel = styled.label`
    font-weight: 600;
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
    color: #4b5563;
    display: block;
`;

export const ErrorText = styled.span`
    color: #ef4444;
    font-size: 0.8125rem;
    margin-top: 0.25rem;
    display: block;
`;

export const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: ${({ $noMargin }) => ($noMargin ? '0' : '1rem')};
    width: 100%;
`;

export const FormFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    margin-top: 1.25rem;
    padding-top: 1.25rem;
    border-top: 1px solid #f3f4f6;
`;

export const StyledCheckbox = styled.input.attrs({ type: 'checkbox' })`
    width: 20px;
    height: 20px;
    accent-color: #821692;
    cursor: pointer;
    margin-right: 0.625rem;
`;

export const StyledRange = styled.input.attrs({ type: 'range' })`
    -webkit-appearance: none;
    width: 100%;
    height: 6px;
    border-radius: 5px;
    background: #e5e7eb;
    outline: none;
    padding: 0;
    margin: 0;

    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background: #821692;
        cursor: pointer;
        transition: background .15s ease-in-out;
        border: 2px solid #fff;
        box-shadow: 0 0 0 1px #821692;
    }

    &::-moz-range-thumb {
        width: 18px;
        height: 18px;
        border: 0;
        border-radius: 50%;
        background: #821692;
        cursor: pointer;
        transition: background .15s ease-in-out;
        border: 2px solid #fff;
        box-shadow: 0 0 0 1px #821692;
    }

    &:focus::-webkit-slider-thumb {
        background: #60106d;
    }
`;
